import { useCallback, useEffect, useLayoutEffect, useRef } from 'react'

export interface GrowableTextarea {
  style: { height: string }
  readonly scrollHeight: number
}

export function resizeTextareaToContent(
  element: GrowableTextarea | null | undefined,
): void {
  if (!element)
    return
  element.style.height = 'auto'
  element.style.height = `${element.scrollHeight}px`
}

const useIsomorphicLayoutEffect
  = typeof window === 'undefined' ? useEffect : useLayoutEffect

export function useAutoGrowTextarea(value: string) {
  const ref = useRef<HTMLTextAreaElement>(null)

  const resize = useCallback(() => {
    resizeTextareaToContent(ref.current)
  }, [])

  useIsomorphicLayoutEffect(() => {
    resize()
  }, [value, resize])

  useEffect(() => {
    window.addEventListener('resize', resize)
    return () => { window.removeEventListener('resize', resize) }
  }, [resize])

  return ref
}
